import { render, staticRenderFns } from "./FornecedorRead.vue?vue&type=template&id=a83c4bc2&"
import script from "./FornecedorRead.vue?vue&type=script&lang=js&"
export * from "./FornecedorRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports